/**
 * Get the initials of a name
 * @param  name - The name to get the initials of
 * @returns The initials of the name
 * @example
 * getNameInitials('John Doe') // 'JD'
 * getNameInitials('Jane Smith') // 'JS'
 * getNameInitials('') // ''
 */
export const getNameInitials = (name: string) => {
  if (!name) return '';

  const words = name.split(' ');
  const initials = words.map((word) => word.charAt(0).toUpperCase());

  return initials.join('').slice(0, 2);
};
